import { render } from "./BaseFileMessage.vue?vue&type=template&id=31ca15a4&scoped=true"
import script from "./BaseFileMessage.vue?vue&type=script&lang=js"
export * from "./BaseFileMessage.vue?vue&type=script&lang=js"

import "./BaseFileMessage.vue?vue&type=style&index=0&id=31ca15a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ca15a4"]])

export default __exports__